import { useAccount, useSubscription, useTranslation } from 'hooks/store';
import { Header } from 'components/Header';
import { Flex } from 'components/UI/Flex';
import { Grid } from 'components/UI/Grid';
import { Spacer } from 'components/UI/Spacer';
import { Suspend } from 'components/UI/Suspend';
import { Typography } from 'components/UI/Typography';
import { Icon } from 'components/UI/Icons';
import { Button } from 'components/UI/Interactables/Button';
import { Tag } from 'components/UI/Tags';

import { Colors, Svgs } from 'environment';

import { InfoCard } from './EnterpriseAdminSubscriptionPage.style';
import { LanguageType } from 'types/index';

export function EnterpriseAdminSubscriptionPage() {
	const { translate } = useTranslation();

	const [
		{
			data: { details },
			loading: subscriptionDetailsLoading
		}
	] = useSubscription();

	const [{ data: accountData }] = useAccount();

	const chosenLanguageCode = accountData?.details?.userPreferences.chosenLanguageCode;
	const isNorwegianSelected = chosenLanguageCode === LanguageType.Norwegian;

	//Opens a new mail towards Ledidi support team
	function newMailToSupport() {
		window.open('mailto:support@ledidi.no?');
	}

	return (
		<>
			<Header.Main />
			<Header.Navigation rightComponent={<Flex></Flex>} />

			<Suspend loading={subscriptionDetailsLoading} immediate={false}>
				<Header.Title
					title={translate(
						({ enterpriseAdmin }) => enterpriseAdmin.header.menuTabs.subscription
					)}
				/>
				<Grid.Container>
					<Flex justify={j => j.between} wrap>
						{/* Subscription name card  */}
						<InfoCard>
							<Flex justify={j => j.between}>
								<Flex align={a => a.center}>
									<Icon
										svg={Svgs.Building}
										variant={v => v.button}
										style={{ background: Colors.background.disabled }}
									/>
									<Typography.H5 breakWord marginOffset={{ x: 1.6 }}>
										{translate(
											({ enterpriseAdmin }) =>
												enterpriseAdmin.subscription.title
										)}
									</Typography.H5>
									<Tag
										title={translate(({ formDesigner }) => formDesigner.active)}
										active
									/>
								</Flex>
							</Flex>
						</InfoCard>
						{/* License Info & detials card*/}
						<InfoCard>
							<Flex align={a => a.center}>
								<Icon
									svg={Svgs.User}
									variant={v => v.button}
									style={{ background: Colors.background.disabled }}
								/>
								<Typography.H5 marginOffset={{ left: 1.6 }}>
									{translate(
										({ enterpriseAdmin }) =>
											enterpriseAdmin.subscription.licenseInfo
									)}
								</Typography.H5>
							</Flex>
							<Typography.Paragraph marginOffset={{ left: 5.6 }}>
								{!isNorwegianSelected
									? `${details?.availableLicenseQuantity}
								${translate(({ enterpriseAdmin }) => enterpriseAdmin.subscription.licensesRemaining)}
								`
									: translate(
											({ enterpriseAdmin }) =>
												enterpriseAdmin.subscription.licensesRemaining,
											false,
											{
												licensesRemaining:
													details?.availableLicenseQuantity ?? ''
											}
									  )}
							</Typography.Paragraph>
							<Typography.Paragraph
								marginOffset={{ left: 5.6 }}
								color={Colors.text.disabled}
							>
								{!isNorwegianSelected
									? `${details?.licenseQuantity}
								${translate(({ enterpriseAdmin }) => enterpriseAdmin.subscription.licensesInPlan)}`
									: translate(
											({ enterpriseAdmin }) =>
												enterpriseAdmin.subscription.licensesInPlan,
											false,
											{ licensesInTotal: details?.licenseQuantity ?? '' }
									  )}
							</Typography.Paragraph>
						</InfoCard>
						{/* Contact support card */}
						<InfoCard>
							<Flex column justify={j => j.between} style={{ height: '100%' }}>
								<div>
									<Flex align={a => a.center}>
										<Icon
											svg={Svgs.Phone}
											variant={v => v.button}
											style={{ background: Colors.background.disabled }}
										/>
										<Typography.H5 marginOffset={{ left: 1.6 }}>
											{translate(
												({ enterpriseAdmin }) =>
													enterpriseAdmin.subscription.contactSupport
											)}
										</Typography.H5>
									</Flex>
									<Typography.Caption marginOffset={{ left: 5.6 }}>
										{translate(
											({ enterpriseAdmin }) =>
												enterpriseAdmin.subscription.contactSupportAlt
										)}
									</Typography.Caption>
								</div>
								<div>
									<Button
										onClick={newMailToSupport}
										title={translate(
											({ enterpriseAdmin }) =>
												enterpriseAdmin.subscription.contactSupport
										)}
										variant={v => v.link}
									/>
								</div>
							</Flex>
						</InfoCard>
					</Flex>
					<Spacer size={s => s.xxl} />
				</Grid.Container>
			</Suspend>
		</>
	);
}
